import API from "@/api";

//文件选择器配置

export default {
	apiObj: API.common.upload,
	menuApiObj: API.common.file.menu,
	listApiObj: API.common.file.list,
	successCode: 200,
	maxSize: 30,
	max: 99,
	uploadParseData: function (res) {
		return {
			id: res.data.id,
			// 后端 upload 响应 data 为 {src, name}，name 为原始文件名
			fileName: res.data.name,
			url: res.data.src
		}
	},
	listParseData: function (res) {
		return {
			rows: res.data.rows,
			total: res.data.total,
			msg: res.message,
			code: res.code
		}
	},
	request: {
		page: 'page',
		pageSize: 'limit',
		keyword: 'title',
		menuKey: 'group_id',
		type:'type'
	},
	menuProps: {
		key: 'id',
		label: 'name',
		children: 'children'
	},
	fileProps: {
		key: 'id',
		fileName: 'original_name',
		url: 'url'
	},
	files: {
		doc: {
			icon: 'mn-icon-file-word-2-fill',
			color: '#409eff'
		},
		docx: {
			icon: 'mn-icon-file-word-2-fill',
			color: '#409eff'
		},
		xls: {
			icon: 'mn-icon-file-excel-2-fill',
			color: '#67C23A'
		},
		xlsx: {
			icon: 'mn-icon-file-excel-2-fill',
			color: '#67C23A'
		},
		ppt: {
			icon: 'mn-icon-file-ppt-2-fill',
			color: '#F56C6C'
		},
		pptx: {
			icon: 'mn-icon-file-ppt-2-fill',
			color: '#F56C6C'
		}
	}
}
